/* FieldEditor.js */

"use strict";

/**
 * @typedef {{Control: {
 *  Textfield: {Textarea: TextareaControlComponent, InputText:InputTextControlComponent, InputNumber:InputNumberControlComponent},
 *  OptionSelection: {Single:{ComboBox:ComboBoxControlComponent}, Multiple:{ComboBox:MultipleComboBoxControlComponent}}
 *  Boolean: {InputCheckbox:InputCheckboxControlComponent}
 * }}} uiCoreTools
 */

/**
 * @type {uiCoreTools}
 */

const uiCore = require("@gluenetworks/steve_ui_core");
const InputTextControl = uiCore.Control.Textfield.InputText;
require("@gluenetworks/jstree");
const $ = require("jquery");
const _ = require("lodash");

class FieldEditor {
    constructor(options) {
        const columnData = options.column;
        const itemData = options.item;

        this.gridInstance = options.grid;
        this.cancelChanges = options.cancelChanges;
        this.commitChanges = options.commitChanges;

        this._itemData = itemData;
        this._isNewItem = Boolean(itemData.isNew);
        this._fieldName = columnData.field;
        this._$container = document.body; //options.container;
        this._$container.style.overflow = "hidden";

        this.initialData = itemData[this._fieldName];

        this.rootElement = this._createRootElement(this._fieldName);
        Object.assign(this.rootElement.style, {
            minWidth: options.position.width + "px",
            minHeight: options.position.height + "px",
        });
        this.position(options.position);

        this.input = this._createInput(this._itemData);
        this.inputTxt = new InputTextControl({
            darkTheme: false,
            placeholder: "Enter search term",
        });

        this._onRootBlur = _.debounce(this._onRootBlur.bind(this), 50);

        this._init();
    }

    _init() {
        this.rootElement.prepend(this.inputTxt.renderer.rootElement);
        this._render();
        this._registerListeners();
    }

    _render() {
        this._$container.append(this.rootElement);
        this.inputTxt.focus();
    }

    _registerListeners() {
        this.rootElement.addEventListener(
            "keydown",
            (this._onRootKeydown = this._onRootKeydown.bind(this))
        );

        this.rootElement.addEventListener(
            "click",
            (this._onRootClick = this._onRootClick.bind(this))
        );
        this.rootElement.addEventListener("blur", (this._onRootBlur = this._onRootBlur.bind(this)));
        this.inputTxt.addListener("UserValue", (this._onUserValue = this._onUserValue.bind(this)));
        this.inputTxt.addListener("UserBlur", (this._onRootBlur = this._onRootBlur.bind(this)));
    }

    _unregisterListeners() {
        this.rootElement.removeEventListener("keydown", this._onRootKeydown);
        this.rootElement.removeEventListener("click", this._onRootClick);
        this.rootElement.removeEventListener("blur", this._onRootBlur);
        this.inputTxt.removeListener("UserValue", this._onUserValue);
        this.inputTxt.removeListener("UserBlur", this._onRootBlur);
    }

    _onUserValue(val) {
        this.input.jstree(true).search(val);
    }

    hide() {}
    show() {}

    /**
     *
     * @param {KeyboardEvent} e
     * @private
     */
    _onRootKeydown(e) {
        const isArrow = e.key.toLowerCase().match("arrow");
        const isEnter = e.key.toLowerCase() === "enter";
        const isEsc = e.key.toLowerCase() === "escape";
        const withCommand = e.metaKey || e.ctrlKey;

        const onInput = e.target.tagName === "INPUT";
        const onTextArea = e.target.tagName === "TEXTAREA";

        if ((onInput && isArrow) || (onTextArea && (isArrow || isEnter))) {
            // do not lose editor on arrow navigation in inputs
            e.stopPropagation();
        }

        if ((isEnter && withCommand) || (isEnter && onInput)) {
            this._save();
            e.stopPropagation();
        }

        if (isEsc) {
            this._cancel();
        }
    }
    _onRootClick(e) {
        e.preventDefault();
        e.stopPropagation();
    }

    _onRootBlur() {
        // de - editor - wrapper field - editor
        if (
            document.activeElement.className.search("jstree") >= 0 ||
            document.activeElement.className.search("de-editor-wrapper") >= 0
        ) {
            return;
        }

        if (document.activeElement.tagName === "INPUT") {
            if (
                document.activeElement.parentElement.parentElement.className.search(
                    "de-editor-wrapper"
                ) >= 0
            ) {
                return;
            }
        }

        _.delay(() => {
            this.gridInstance && this.gridInstance.getEditorLock().commitCurrentEdit();
        }, 100);
    }

    _createRootElement(fieldName) {
        const rootElement = document.createElement("div");
        rootElement.classList.add("de-editor-wrapper", `${fieldName}-editor`);
        rootElement.setAttribute("tabindex", 0);
        rootElement.component = this;
        return rootElement;
    }

    _createInput(data) {
        this._treeTestCont = document.createElement("div");
        this._treeTestCont.classList.add("tree-selector");
        this.rootElement.appendChild(this._treeTestCont);
        const treeData = data.deviceNodeTreeData;
        const explorables = data.solutions;
        // const explorables = this._model._explorablesEntity.getExplorables();
        const treeSelector = $(this._treeTestCont).jstree({
            core: {
                data: treeData,
                themes: {
                    dots: false,
                },
            },
            search: {
                show_only_matches: true,
                show_only_matches_children: true,
            },
            plugins: ["search"],
        });

        $(this._treeTestCont).on("changed.jstree", (e, data) => {
            const name = data.node.text;
            const parents = [];
            let fullName = "";
            let field = explorables;
            if (data.node.parents.length > 1) {
                for (let i = data.node.parents.length - 2; i >= 0; i--) {
                    parents.push(data.instance.get_node(data.node.parents[i]).text);
                    field = field[data.instance.get_node(data.node.parents[i]).text];
                    fullName += data.instance.get_node(data.node.parents[i]).text + ">";
                }
            }
            field = field[name];
            fullName += name;
            if (!field.path) {
                return;
            }
            this._value = fullName;
            data.instance.close_all();
            this.gridInstance.getEditorLock().commitCurrentEdit();
        });
        return treeSelector;
    }

    _getValue() {
        // return this.input.getValue();
        return this._value;
    }

    _cancel() {
        // this.input.setValue(this.initialData);
        this.cancelChanges();
    }

    _save() {
        this.commitChanges();
    }
    /*****************************/
    /*       PUBLIC API          */
    /*****************************/
    destroy() {
        this._unregisterListeners();
        this.rootElement.remove();
        this._$container.style.removeProperty("overflow");
        return Promise.resolve()
            .then(/*() => this.input.destroy()*/ () => Promise.resolve())
            .then(() => {
                this.input = null;
                this.rootElement = null;
                this.gridInstance = null;
                this._$container = null;
                this._itemData = null;
            });
    }

    focus() {
        // this.input.focus();
    }

    // show() {
    //     this.rootElement.style.removeProperty("display");
    // }

    // hide() {
    //     this.rootElement.style.setProperty("display", "none");
    // }

    position({top, left}) {
        Object.assign(this.rootElement.style, {
            top: `${top}px`,
            left: `${left}px`,
        });
    }

    /**
     * is used to load value from item Data and set it to 'input'
     * @param {ItemData} item
     */
    loadValue(item) {
        const fieldValue = item[this._fieldName];
        if (!fieldValue) {
            return;
        }
        this.initialData = fieldValue;
        // this.input.setValue(fieldValue);
    }

    /**
     * is used to get data from 'input'
     * @returns {*}
     */
    serializeValue() {
        return this._getValue();
    }

    /**
     * is used to apply new data back to Item
     * @param {ItemData} item - grid data Item
     * @param {*} state - result of serializeValue
     */
    applyValue(item, state) {
        if (!state) {
            return;
        }
        item[this._fieldName] = state;
        const path = state.split(">");
        const explorables = item.solutions;
        const fl = path.reduce((acc, val) => {
            return acc[val];
        }, explorables);

        if (item.type === "netBox" || item.type === "xDome") {
            item.gwPropPath = fl.path;
            item.gwPropType = fl.dataType;
        } else {
            item.devicePropPath = fl.path;
            item.devicePropType = fl.dataType;
        }
    }

    /**
     * Compares initial and edited data.
     * If false the destroy will be called the next.
     * If true validate will be called the next.
     * @returns {boolean}
     */
    isValueChanged() {
        return JSON.stringify(this.initialData) !== JSON.stringify(this._getValue());
    }

    /**
     * checks if data is valid
     *
     * @returns {{valid: boolean, msg: ?string}}
     */

    validate() {
        // const isInvalid = this.input.isInvalid();
        // const msg = typeof isInvalid === "string" ? isInvalid : null;
        return {
            valid: true,
            msg: "",
        };
    }
}

module.exports = FieldEditor;
